import styled from 'styled-components';
import LBHead8 from 'dc/LBHead8';

export const Wrapper = styled.div`
  width: 100%;
  background: #fff;
  border-radius: 4px;
  margin-top: 16px;
`;

export const Table = styled.table`
  width: 100%;
  border-spacing: 0;
`;

export const LeaderboardWrapper = styled.tbody`
  & > tr:nth-child(odd) {
    background-color: #effafa;
  }
`;

export const Header = styled(LBHead8)`
  background-color: white;
  width: 100%;
  margin-bottom: 8px;
`;
